import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-vaps-vehicle-three',
    templateUrl: './vaps-vehicle-three.component.html',
    styleUrls: ['./vaps-vehicle-three.component.scss'],
    standalone: false
})
export class VapsVehicleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
